import { assocPath, compose, dissocPath, equals, hasPath, is, path, prop, startsWith, when } from 'ramda';
import { isNilOrEmpty, isNotNilOrEmpty } from 'ramda-adjunct';
import { uploadFiles } from '../lib/uploadFiles';
import { errorMessage } from './messageMutation';

const FRAME_UPLOAD_IMAGE_PATH = ['frameStyle', 'uploadImage'];
const FRAME_BACKGROUND_IMAGE_PATH = ['frameStyle', 'backgroundImage'];

const isBlobUrl = (value) => is(String, value) && startsWith('blob:', value);

export const uploadBackgroundImage = async (file, options = {}) => {
  const uploadedFile = await uploadFiles(file, options);
  const fileId = prop('fileId', uploadedFile);
  if (isNilOrEmpty(fileId)) throw new Error('Missing uploaded background image reference');
  return `/files/${fileId}`;
};

// True when the error message has already been shown to the user.
export const isReportedError = compose(equals(true), path(['isReported']));

// Shows the error message to the user and flags the error so callers do not show it a second time.
const reportError = (error, content) => {
  errorMessage(content);
  if (is(Object, error)) error.isReported = true;
  return error;
};

// Replaces the frame background image picked in the editor by a persistable source.
export const resolveFrameBackgroundImage = async (values, getImageSrc) => {
  const uploadImage = path(FRAME_UPLOAD_IMAGE_PATH, values);
  let resolvedValues = when(hasPath(FRAME_UPLOAD_IMAGE_PATH), dissocPath(FRAME_UPLOAD_IMAGE_PATH), values);

  if (isNotNilOrEmpty(uploadImage)) {
    let imageSrc;
    try {
      imageSrc = await getImageSrc(await uploadImage);
    } catch (error) {
      throw reportError(error, 'Échec de l\'envoi de l\'image de fond, veuillez réessayer.');
    }
    resolvedValues = assocPath(FRAME_BACKGROUND_IMAGE_PATH, imageSrc, resolvedValues);
  }

  if (isBlobUrl(path(FRAME_BACKGROUND_IMAGE_PATH, resolvedValues))) {
    throw reportError(
      new Error('A blob: background image can not be persisted.'),
      'L\'image de fond n\'a pas pu être enregistrée, veuillez la sélectionner à nouveau.'
    );
  }

  return resolvedValues;
};